import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import About from "./components/About";
import AllProductPage from "./components/AllProductPage";
import Login from "./components/Auth/Login/index";
import Profile from "./components/Auth/Profile";
import BecomeSaller from "./components/BecomeSaller";
import CardPage from "./components/CartPage";
import CheakoutPage from "./components/CheakoutPage";
import Contact from "./components/Contact";
import Faq from "./components/Faq";
import FlashSale from "./components/FlashSale";
import FourZeroFour from "./components/FourZeroFour";
import Home from "./components/Home";
import PrivacyPolicy from "./components/PrivacyPolicy";
import SallerPage from "./components/SallerPage";
import Sallers from "./components/Sellers";
import SingleProductPage from "./components/SingleProductPage";
import TermsCondition from "./components/TermsCondition/index";
import Tutorial from "./components/Tutorial/index";
import TrackingOrder from "./components/TrackingOrder";
import { useEffect, useState } from "react";
import { ErrorToaster, ToasterContainer } from "./components/Helpers/toaster/Toaster";
import MembershipPlan from "./components/MembershipPlan";
import RegisterSuccess from "./components/RegisterSuccess";
import { useAuth } from "./context/UseContext";
import ShippingPolicy from "./components/ShippingPolicy";
import RefundPolicy from "./components/RefundPolicy";
import Chat from "./components/Chat/index.js";
import GuestBuyer from "./components/GuestBuyer/index.jsx";
import CartServices from "./apis/cart/CartServices.js";
import { useDispatch } from "react-redux";
import { updateCart } from "./redux/slices/userDataSlice.js";
import { PusherProvider } from "./hooks/usePusher.js";
import { Box, IconButton } from "@mui/material";
import { ArrowUpward } from "@mui/icons-material";

export default function Routers() {

  const { user } = useAuth();
  const dispatch = useDispatch();

  const [showScrollTop, setShowScrollTop] = useState(false);

  // *For Get Cart Data
  const getCartData = async () => {
    try {
      const { data } = await CartServices.getCartData()
      dispatch(updateCart(JSON.parse(data?.cart)))
    } catch (error) {
      ErrorToaster(error)
    }
  }

  useEffect(() => {
    if (user?.token) {
      getCartData()
    }
  }, [user]);

  // Scroll to top functionality
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <PusherProvider>

      {/* ========== Chat ========== */}
      <Chat />

      {/* ========== Toaster ========== */}
      <ToasterContainer />

      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/all-products" element={<AllProductPage />} />
        <Route exact path="/single-product/:id" element={<SingleProductPage />} />
        <Route exact path="/cart" element={<CardPage />} />
        <Route exact path="/flash-sale/:id" element={<FlashSale />} />
        <Route exact path="/seller-page/:id" element={<SallerPage />} />
        <Route exact path="/sellers" element={<Sallers />} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/tracking-order" element={<TrackingOrder />} />
        <Route exact path="/contact" element={<Contact />} />
        <Route exact path="/faq" element={<Faq />} />
        <Route element={user?.token ? <Navigate to="/" /> : <Outlet />} >
          <Route exact path="/login" element={<Login />} />
        </Route>
        <Route element={user?.token ? <Outlet /> : <Navigate to="/login" />} >
          <Route exact path="/checkout" element={<CheakoutPage />} />
        </Route>
        <Route exact path="/profile" element={<Profile />} />
        <Route exact path="/register" element={<BecomeSaller />} />
        <Route exact path="/guest-register" element={<GuestBuyer />} />
        <Route exact path="/membership-plan" element={<MembershipPlan />} />
        <Route exact path="/register-success" element={<RegisterSuccess />} />
        <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route exact path="/shipping-policy" element={<ShippingPolicy />} />
        <Route exact path="/refund-policy" element={<RefundPolicy />} />
        <Route exact path="/terms-condition" element={<TermsCondition />} />
        <Route exact path="/tutorial" element={<Tutorial />} />
        <Route exact path="*" element={<FourZeroFour />} />
      </Routes>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <Box
          sx={{
            position: 'fixed',
            right: '15px',
            bottom: '85px',
            zIndex: '9999',
          }}
        >
          <IconButton
            onClick={() => scrollToTop()}
            sx={{
              p: 2,
              color: '#fff',
              bgcolor: '#000',
              '&:hover': {
                bgcolor: '#000',
              }
            }}
          >
            <ArrowUpward />
          </IconButton>
        </Box>
      )}

    </PusherProvider>
  );
}
